import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ViewsByProfile from './ViewsByProfile/ViewsByProfile';
import FilterItems from '../FilterItems/FilterItems';

const Profiles = ({
    registrationIdsSelected
}) => {
    const [id, setId] = useState(null);
    const [profile, setProfile] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [usernameUpdate, setUsernameUpdate] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(false);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingProfilePanel, setLoadingProfilePanel] = useState(null);
    const [profileRecords, setProfilesRecords] = useState(null);
    const [attributesDetailProfilePanel, setAttributesDetailItemPanel] = useState(null);
    const [profilesIdsSelected, setProfilesIdsSelected] = useState([]);
    const [isActiveFilter, setIsActiveFilter] = useState('S');
    const readOnlyAttributes = !(inserting || updating);


    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "profile", value: profile, setter: setProfile },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S', readOnlyGrid: true,
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "usernameUpdate", value: usernameUpdate, setter: setUsernameUpdate },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setProfilesIdsSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListProfiles()
    }, [registrationIdsSelected, isActiveFilter])

    useEffect(() => {
        // A grid é recarregada após salvar (post/put); selecionar uma linha só busca o detalhe
        if ((!profilesIdsSelected || profilesIdsSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!profilesIdsSelected || profilesIdsSelected.length > 1) {
            setProfilesIdsSelected([])
        }
    }, [profilesIdsSelected, updating]);


    useEffect(() => {
        if (profilesIdsSelected && profilesIdsSelected.length === 1) {
            fetchDataDetail(profilesIdsSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [profilesIdsSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '83%',
    };

    async function reloadListProfiles() {
        const parameters = { onlyActive: isActiveFilter }
        const profiles = await ExecuteAxios.api('get', `/profile/get-profile-grid/`, { params: parameters });
        setProfilesRecords(profiles);

        if (profiles) {
            RemoveIdsNotFound.remove(profiles, setProfilesIdsSelected, profilesIdsSelected)
        }
    }

    const fetchDataDetail = async (profilesIdsSelected) => {
        const parameters = { id: profilesIdsSelected ? profilesIdsSelected : 0 }
        const item = await ExecuteAxios.api('get', `/profile/get-profile-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!profilesIdsSelected || profilesIdsSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setProfilesIdsSelected}
                    idsSelected={profilesIdsSelected}
                    data={profileRecords}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProfilePanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingProfilePanel(true)
            const response = await ExecuteAxios.api('post', `/profile/`, {
                profile: profile,
                isActive: isActive
            });

            if (response) {
                await reloadListProfiles()
            }
            return response;
        } finally {
            setLoadingProfilePanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingProfilePanel(true)
            const response = await ExecuteAxios.api('put', `/profile/`, {
                id: id,
                profile: profile,
                isActive: isActive
            });

            if (response) {
                await reloadListProfiles()
            }

            return response;
        } finally {
            setLoadingProfilePanel(false)
        }
    }

    return (
        <div style={{
            display: 'flex', flexDirection: 'row', height: '100%', width: '100%'
        }}>
            <div style={{
                display: 'flex', flexDirection: 'column', height: '100%', width: '100%'
            }}
                className={'main-modal two left'}
            >

                <FilterItems
                    isActiveFilter={isActiveFilter}
                    onUpdatesIsActiveFilter={setIsActiveFilter}
                />

                <Panel
                    style={itemPanelStyle}
                    titlePage={'Perfis'}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canEdit={profilesIdsSelected && profilesIdsSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                    putFunction={putItem}
                    enableNewRecord={true}
                    canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                    postFunction={postItem}
                    canViewCRUD={true}
                    readOnly={false}
                    recordsSelected={profilesIdsSelected}
                    viewOnlyOneRecordCRUD={true}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={attributesDetailProfilePanel}
                    attributeList={attributeList}
                    onUpdateIdSelected={setProfilesIdsSelected}
                >
                    <LoadingIndicator loaded={!loadingProfilePanel}>
                        {getItemPanelListOrDetail()}
                    </LoadingIndicator>
                </Panel>
            </div>
            <ViewsByProfile
                profilesIdsSelected={profilesIdsSelected}
            />
        </div>
    );

}
export default Profiles;